const CrunchClassManager = require('crunch-class-manager').default;
export default CrunchClassManager;
